import ServiceBusController from "servicestack/service-bus.controller";
import $resolve from "ng";

export default class ForgotPasswordController extends ServiceBusController {
  $onInit() {
    const $ctrl = this;
    delete $ctrl.bus.validationErrors;
    $ctrl.request = Object.assign(
      { callbackUrl: window.location.href },
      $resolve("$location").search()
    );
    ["callbackUrl", "resetId", "token"].forEach(n => {
      if ($ctrl[n] && $ctrl[n].length) {
        $ctrl.request[n] = $ctrl[n];
      }
    });
  }

  redirect(url) {
    window.location.replace(url);
  }

  beginChangePassword() {
    let $ctrl = this;
    return $ctrl.bus
      .send(`ResetPassword.json`, $ctrl.request)
      .then(({ data }) => {
        Object.assign($ctrl.request, data);
        $ctrl.message =
          "Your verification code was emailed to: " + $ctrl.request.email;
        $ctrl.onVerificationCodeSent({ window, location, data });
      });
  }

  completeChangePassword() {
    const $ctrl = this;
    return $ctrl.bus
      .send(`ChangePassword.json`, $ctrl.request)
      .then(({ data }) => {
        if ($ctrl.loginUrl) return $ctrl.redirect($ctrl.loginUrl);
        $ctrl.onPasswordChanged({ window, location, data });
      });
  }
}
